// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.students-table table {
  border-collapse: separate;
  border-spacing: 0px;
  width: 100%;
}
.students-table table thead > tr > th {
  border-radius: 5px 5px 0 0;
  background-color: #C0DEF0;
  border-color: #A7A9AC;
  border-style: solid;
  border-width: 1px;
  color: #0A4064;
  font-size: 0.85rem;
  font-weight: 500;
  padding: 5px;
  text-align: center;
}
.students-table table tbody > tr {
  border-left: 1px solid #A7A9AC;
  border-right: 1px solid #A7A9AC;
}
.students-table table tbody > tr.stripe {
  background-color: #EDf0F1;
}
.students-table table tbody > tr > td {
  font-size: 0.78rem;
  padding: 3px;
  border-right: 1px solid #D1D3D4;
}
.students-table table tbody > tr > td.email {
  max-width: 10%;
  width: 180px;
  word-wrap: anywhere;
}
.students-table table td.center {
  text-align: center;
}
.students-table table tbody > tr > td.first {
  border-left: 1px solid #A7A9AC;
}
.students-table table tbody > tr > td.last {
  border-right: 1px solid #A7A9AC;
}
.students-table table tfoot > tr {
  background-color: white;
}
.students-table table tfoot > tr > td {
  border-top: 1px solid #A7A9AC;
  padding-top: 10px;
}
.students-table table tfoot > tr > td > div {
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  margin: 0 auto;
}
.students-table table tfoot > tr > td > div > .showing-records {
  font-size: 0.8rem;
  font-style: italic;
  margin-top: 5px;
  position: absolute;
  right: 4%;
}

form#student-form div.input-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 3px;
}
form#student-form input, form#student-form label, form#student-form select {
  border-radius: 3px;
  display: block;
  width: 50% !important;
}
form#student-form input, form#student-form select {
  border-radius: 5px;
  border: none;
  border: 1px solid #808080;
  padding: 5px;
  min-width: 180px !important;
}
form#student-form label {
  color: #333;
  font-size: 0.9rem;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/Students.scss","webpack://./src/styles/global/globalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AANI;EACI,yBAAA;EACA,mBAAA;EACA,WAAA;AASR;AARQ;ECLJ,0BDM8B;EACtB,yBDgBA;ECfA,qBDSJ;ECRI,mBAAA;EACA,iBAAA;EACA,cDCF;ECAE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AAUZ;AARQ;EACI,8BAAA;EACA,+BAAA;AAUZ;AARQ;EACI,yBDPJ;ACiBR;AARQ;EACI,kBAAA;EACA,YAAA;EACA,+BAAA;AAUZ;AARQ;EACI,cAAA;EACA,YAAA;EACA,mBAAA;AAUZ;AARQ;EACI,kBAAA;AAUZ;AARQ;EACI,8BAAA;AAUZ;AARQ;EACI,+BAAA;AAUZ;AARQ;EACI,uBAAA;AAUZ;AARQ;EACI,6BAAA;EACA,iBAAA;AAUZ;AARQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,cAAA;AAUZ;AARQ;EACI,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;AAUZ;;AAJI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAOR;AALI;EC1EA,kBD2E0B;EACtB,cAAA;EACA,qBAAA;AAOR;AALI;EC/EA,kBAgCsB;EACtB,YAAA;EACA,yBAAA;EACA,YAAA;ED8CI,2BAAA;AAUR;AARI;EACI,WD9DA;EC+DA,iBAAA;EACA,gBAAA;AAUR","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n$lt-blue: #7DB7CC;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$green: #C7CC68;\n$DCSD-logo-green: #84ae30;\n$dashboard-blue: #0d6efd;\n$dk-blue: #0A4064;\n$important: #FEBF31;\n$highlight: #FDF9D0;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$grey5: #333;\n$pale-blue: #C0DEF0;\n$pearl-dk-blue: #0762a7;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n$teal-logo: #46A8B0;\n\n$pale-blue-green: #9acdd2;\n$pale-blue-green-outline: #75c2c9;\n\n$pale-purple: #bca0d3;\n$pale-purple-outline: #946eb4;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.students-table {\n    table{\n        border-collapse: separate;\n        border-spacing: 0px;\n        width: 100%;\n        thead>tr>th {\n            @include borderRadius(5px 5px 0 0);\n            background-color: $pale-blue;\n            border-color: $grey2;\n            border-style: solid;\n            border-width: 1px;\n            color: $dk-blue;\n            font-size: 0.85rem;\n            font-weight: 500;\n            padding: 5px;\n            text-align: center;\n        }\n        tbody>tr {\n            border-left: 1px solid $grey2;\n            border-right: 1px solid $grey2;\n        }\n        tbody>tr.stripe {\n            background-color: $grey0;;\n        }\n        tbody>tr>td {\n            font-size: 0.78rem;\n            padding: 3px;\n            border-right: 1px solid $grey1;\n        }\n        tbody>tr>td.email {\n            max-width: 10%;\n            width: 180px;\n            word-wrap: anywhere;\n        }\n        td.center {\n            text-align: center;\n        }\n        tbody>tr>td.first {\n            border-left: 1px solid $grey2;\n        }\n        tbody>tr>td.last {\n            border-right: 1px solid $grey2;\n        }\n        tfoot>tr {\n            background-color: white;\n        }\n        tfoot>tr>td {\n            border-top: 1px solid $grey2;\n            padding-top: 10px;\n        }\n        tfoot>tr>td>div {\n            display: flex;\n            flex-direction: row;\n            justify-content: center;\n            width: 100%;\n            margin: 0 auto;\n        }\n        tfoot>tr>td>div>.showing-records {\n            font-size: 0.8rem;\n            font-style: italic;\n            margin-top: 5px;\n            position: absolute;\n            right: 4%;\n        }\n    }\n}\n\nform#student-form {\n    div.input-row {\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        margin-bottom: 3px;\n    }\n    input, label, select {\n        @include borderRadius(3px);\n        display: block;\n        width: 50% !important;\n    }\n    input, select {\n        @include standardInput();\n        min-width: 180px !important;\n    }\n    label {\n        color: $grey5;\n        font-size: 0.9rem;\n        font-weight: 500;\n    }\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
